import { useAtom } from "jotai";
import {
  resetTokenAtom,
  isRegisteringAtom,
  isRecoveringAtom,
  isSettingNewPasswordAtom,
  passwordAtom,
  firstNameAtom,
  lastNameAtom,
  errorAtom,
  successMessageAtom,
  referrerAtom,
} from "../../store/atoms/authAtoms.js";
import { emailAtom } from "../../store/atoms/userAtoms.js";

// Auth State Hook
export const useAuth = () => {
  const [resetToken, setResetToken] = useAtom(resetTokenAtom);
  const [isRegistering, setIsRegistering] = useAtom(isRegisteringAtom);
  const [isRecovering, setIsRecovering] = useAtom(isRecoveringAtom);
  const [isSettingNewPassword, setIsSettingNewPassword] = useAtom(
    isSettingNewPasswordAtom
  );
  const [password, setPassword] = useAtom(passwordAtom);
  const [firstName, setFirstName] = useAtom(firstNameAtom);
  const [lastName, setLastName] = useAtom(lastNameAtom);
  const [error, setError] = useAtom(errorAtom);
  const [successMessage, setSuccessMessage] = useAtom(successMessageAtom);
  const [referrer, setReferrer] = useAtom(referrerAtom);
  const [email, setEmail] = useAtom(emailAtom);

  return {
    resetToken,
    setResetToken,
    isRegistering,
    setIsRegistering,
    isRecovering,
    setIsRecovering,
    isSettingNewPassword,
    setIsSettingNewPassword,
    password,
    setPassword,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    error,
    setError,
    successMessage,
    setSuccessMessage,
    referrer,
    setReferrer,
    email,
    setEmail,
  };
};
